// NOTE: Do not add any external dependency here! This util is used inside independent "bettingLoader".
import baseLocaleManager, {
    Config as ConfigBase,
    Extensions as ExtensionsBase,
    LocaleManagerInterface,
} from '@gin-betting/locale-manager';
import type { LocaleData } from 'i18n-iso-countries';

import { DEFAULT_LOCALE, LOCALES } from './constants';

export interface Config extends ConfigBase {
    banner: string; // TODO: remove after CMS pass "getBanners" thought BettingAPI. GINFE-2607
    i18nCountries: string;
    transifex: string;
    matchTracker: string;
    polyfill: string;
    reactIntl: string;
    dateFns: string;
}

export interface Extensions extends ExtensionsBase {
    messages: any;
    i18nCountries: LocaleData;
}

const localeManager = (baseLocaleManager as unknown) as LocaleManagerInterface<
    Config,
    Extensions
>;

localeManager.set(LOCALES, DEFAULT_LOCALE);

export default localeManager;
